export const CLASS_ALWAYS_KNOWN_SPELLS_SET = 'serviceData.CLASS_ALWAYS_KNOWN_SPELLS_SET';
export const CLASS_ALWAYS_KNOWN_SPELLS_SET_COMMIT = 'serviceData.CLASS_ALWAYS_KNOWN_SPELLS_SET_COMMIT';
